export enum Actions {
  "CREATE",
  "UPDATE",
  "DELETE",
  "MOVE",
}
